import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiEndPoint, StatusCode } from "../../services/helper";
import API from "../../services/api";
const initialState = {
  DashboardListingData: {},
  registeredKitData: {},
  status: StatusCode.IDLE,
  registeredKitStatus: StatusCode.IDLE,
};
const { DASHBOARDLISTING, REGISTEREDKIT, INJURY_TYPE_DATA, FETCH_HEATMAP } =
  ApiEndPoint;
export const DashboardListingSlice = createSlice({
  name: "DashboardList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardListingData.pending, (state) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(fetchDashboardListingData.fulfilled, (state, action) => {
        state.DashboardListingData = action.payload;
        state.status = StatusCode.IDLE;
      })
      .addCase(fetchDashboardListingData.rejected, (state) => {
        state.status = StatusCode.ERROR;
      })
      .addCase(fetchRegisteredKitData.pending, (state) => {
        state.registeredKitStatus = StatusCode.LOADING;
      })
      .addCase(fetchRegisteredKitData.fulfilled, (state, action) => {
        state.registeredKitData = action.payload;
        state.registeredKitStatus = StatusCode.IDLE;
      })
      .addCase(fetchRegisteredKitData.rejected, (state) => {
        state.registeredKitStatus = StatusCode.ERROR;
      });
  },
});

export const {} = DashboardListingSlice.actions;
export default DashboardListingSlice.reducer;

export const fetchDashboardListingData = createAsyncThunk(
  "admin/get/dashboard-listing",
  async () => {
    try {
      const res = await API.get(DASHBOARDLISTING);
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      console.error("Failed to fetch dashboard listing data:", error);
      throw error;
    }
  }
);

export const fetchRegisteredKitData = createAsyncThunk(
  "admin/get/registered-kits",
  async (query) => {
    try {
      const res = await API.get(`${REGISTEREDKIT}?range=${query}`);
      if (res.status === 200) {
        return res?.data?.data ?? {};
      }
    } catch (error) {
      console.error("Failed to fetch dashboard listing data:", error);
      throw error;
    }
  }
);

export const fetchIncidentDetails = createAsyncThunk(
  "admin/get/incident-details",
  async (query) => {
    try {
      const res = await API.get(`${INJURY_TYPE_DATA}?type=${query}`);
      if (res.status === 200) {
        return res?.data ?? {};
      }
    } catch (error) {
      console.error("Failed to fetch dashboard listing data:", error);
      throw error;
    }
  }
);

export const fetchHeatMapData = createAsyncThunk(
  "admin/get/heatmap-data",
  async () => {
    try {
      const res = await API.get(`${FETCH_HEATMAP}`);
      if (res.status === 200) {
        return res?.data ?? {};
      }
    } catch (error) {
      console.error("Failed to fetch dashboard listing data:", error);
      throw error;
    }
  }
);
